import { Component, OnInit, inject } from '@angular/core';
import {
  BackendDataSourceService,
  ItemView,
  ItemViewProviderDirective,
  NtapCommonComponent
} from '@ntap/core';
import { switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-spremiste-spremisne-jedinice',
  templateUrl: './spremiste-spremisne-jedinice.component.html',
  styleUrls: ['./spremiste-spremisne-jedinice.component.scss']
})
export class SpremisteSpremisneJediniceComponent
  extends NtapCommonComponent
  implements OnInit
{
  constructor(protected itemViewProvider: ItemViewProviderDirective<ItemView>) {
    super();
  }
  backendService = inject(BackendDataSourceService);

  parentArchiveName: string;
  parentObjectName: string;
  parentProstorijaName: string;
  parentProstorijaArea: string;
  parentObjectAdress: string;
  parentObjectArea: string;
  spremisnaJedinicaName: string;

  ngOnInit() {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          switchMap((data: any) => {
            this.spremisnaJedinicaName =
              (data['earhiv~spremiste_spremisna_jedinica~identifikator']
                ? data['earhiv~spremiste_spremisna_jedinica~identifikator'] +
                  ' '
                : '') +
              (data['earhiv~spremiste_spremisna_jedinica~naziv']
                ? data['earhiv~spremiste_spremisna_jedinica~naziv']
                : '');

            return this.backendService.getViewData('spremiste_prostorije', {
              ['earhiv~spremiste_prostorija~id']:
                data[
                  'earhiv~spremiste_spremisna_jedinica~spremiste_prostorija_id'
                ]
            });
          }),
          tap((parentObject: any) => {
            this.parentProstorijaName =
              parentObject[0]['earhiv~spremiste_prostorija~identifikator'] +
              ' ' +
              parentObject[0]['earhiv~spremiste_prostorija~naziv'];
            this.parentProstorijaArea =
              parentObject[0]['earhiv~spremiste_prostorija~povrsina'];
          }),
          switchMap((data: any) => {
            return this.backendService.getViewData('spremiste_objekti', {
              ['earhiv~spremiste_objekt~id']:
                data['earhiv~spremiste_prostorija~spremiste_objekt_id']
            });
          }),
          tap((parentObject: any) => {
            this.parentObjectName =
              parentObject[0]['earhiv~spremiste_objekt~identifikator'] +
              ' ' +
              parentObject[0]['earhiv~spremiste_objekt~naziv'];
            this.parentObjectAdress =
              parentObject[0]['earhiv~spremiste_objekt~adresa'];
            this.parentObjectArea =
              parentObject[0]['earhiv~spremiste_objekt~povrsina'];
          }),
          switchMap((item: any) =>
            this.backendService
              .getViewData('spremiste_nadredeni-arhiv', {
                'en~arhiv_posjednik~id':
                  item[0]['earhiv~spremiste_objekt~arhiv_id']
              })
              .pipe(
                tap((viewData: any) => {
                  this.parentArchiveName =
                    viewData.length > 0 && viewData[0]['en~agent~naziv'];
                })
              )
          )
        )
        .subscribe()
    );
  }
}
